<template>
  <div>
    <header-unauthenticated></header-unauthenticated>
    <div class="container">
      <div class="login login--header-padding">
        <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
        <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
        <h4>{{$t('register.activateUser.legend')}}</h4>

        <div class="form-group">
          <input 
          type="number"
          v-model.trim="$v.code.$model"
          :class="{'has-error': $v.code.$error && $v.code.$invalid, 'with-value': $v.code.$model != ''}"
          :id="$t('register.activateUser.form.code')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('register.activateUser.form.code')">{{$t('register.activateUser.form.code')}}</label>
        </div>
        <button class="button button--white" @click.prevent="userActivate()" :disabled="$v.code.$invalid || loading">
          <template v-if="!submitted">
            {{$t('register.activateUser.verifyCode')}}
          </template>
          <template v-else>
            {{$t('register.activateUser.loading')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
          </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import HeaderUnauthenticated from '@/components/Header/Unauthenticated.vue'
import PersistentData from '@/plugins/persistentData'

export default {
  components: {
    HeaderUnauthenticated
  },
  data() {
    return {
      code: "",
      submitted: false
    }
  },
  methods: {
    async userActivate() {
      const self = this
      self.$v.$touch()
      if (!self.$v.$invalid) {
        this.submitted = true
        const request = await this.$store.dispatch('endChangeAppleMail', {
          code: self.code
        })
        if (request == undefined) this.submitted = false
        if (request.status == 200) {
          PersistentData.setData('token', request.data)
          const profile = await this.$store.dispatch("profileGet")
          if (profile.data.birthDate == null && profile.data.team == null) {
            this.$router.push('/login/onboarding')
          } else {
            this.$router.push('/home/games')
          }
        }
      }
    }
  },
  validations: {
    code: {
      required
    }
  }
}
</script>